export default {
  tip: '是否前往支付页面？',
  label: {
    amount: '金额',
    code: '通道编码',
    merchantNo: '商户号',
    notifyUrl: '回调地址',
    outTradeNo: '商户订单号',
    sign: '签名',
    timestamp: '时间戳',
    type: '通道类型',
    params: '参数',
    getmerchantNo: '获取订单号',
    payLine: '支付链接',
    checkout: '收银台',
    bankCardNumber:'银行卡号',
    username:'用户名',

  },
  rules: {
    amount: {
      required: '金额不能为空',
      type: '金额只能为正整数'
    },
    code: {
      required: '通道编码不能为空'
    },
    merchantKey: {
      required: '商户密钥不能为空'
    },

    selfMerchantNo: {
      required: '商户订单号必须获取'
    },

    merchantNo: {
      required: '商户号不能为空'
    },
    notifyUrl: {
      required: '回调地址不能为空',
      format: '回调地址必须是http地址'
    },
    outTradeNo: {
      required: '商户订单号不能为空'
    },
    sign: {
      required: '签名不能为空'
    },
    timestamp: {
      required: '时间戳不能为空'
    },
    type: {
      required: '通道类型必须选择'
    },
    bankCode: {
      required: '银行编码不能为空'
    },
    bankCardNumber: {
      required: '银行卡号不能为空'
    },

  },
  copy: '复制成功'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh/channelTest.js